import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getStatus: EvokeAction<AppState, AppActions> = async store => {
  try {
    const status = await api.get("status");
    
    await store.update(state => {
      state.status = status;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const statusActions = {
  getStatus
};
